/* @ngInject */
export default function ($window, $document, $rootScope) {
	return {
		link: (scope, element) => {
			const triggerResize = () => {
				const navbar         = angular.element('.navbar-static-top');
				const pageHeading    = angular.element('.page-heading');
				const wrapperContent = angular.element('.wrapper-content'); // Includes extra padding for the footer

				const navbarHeight         = navbar.outerHeight(true);
				const pageHeadingHeight    = pageHeading.outerHeight(true);
				const wrapperContentHeight = wrapperContent.outerHeight(true);

				const pageHeight   = navbarHeight + pageHeadingHeight + wrapperContentHeight;
				const windowHeight = $window.innerHeight;

				element.css('min-height', Math.max(pageHeight, windowHeight) + 'px');
			};

			triggerResize();

			angular.element($window)
			       .on('resize', triggerResize);

			scope.$on('destroy', () => {
				angular.element($window)
				       .off('resize', triggerResize);
			});

			scope.$watch(() => {
				return $document.height();
			}, (newValue, oldValue) => {
				triggerResize();
			});

			$rootScope.$on('sidebar.triggerResize', triggerResize);
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/sidebar/index.js